import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LinkIcon from '@mui/icons-material/Link';

const useStyles = makeStyles((theme) => ({
  content: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    marginBottom: -1,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    backgroundPosition: 'center',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
}));

const MediaItemThumbTableCell = (props) => {
  const { mediaItem } = props;
  const { thumbUrl } = mediaItem;

  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box
        width={{ xs: 0, md: 80 }}
        height={{ xs: 0, md: 45 }}
        className={classes.content}
        style={{ backgroundImage: thumbUrl ? `url(${thumbUrl})` : undefined }}
      >
        <Box
          className={classes.overlay}
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          color="white"
        >
          {mediaItem.isExternal ? <LinkIcon /> : <OndemandVideoIcon />}
        </Box>
      </Box>
    </Box>
  );
};

MediaItemThumbTableCell.propTypes = {
  mediaItem: PropTypes.object,
};

MediaItemThumbTableCell.defaultProps = {
  mediaItem: {},
};

export default MediaItemThumbTableCell;
